import styled from "styled-components";
import { Button } from "@mui/material";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";

export const TopbarViewButton = styled(Button)`
    && {
        height: 28px;
        ${(props) =>
            props.color === UIStyleConstants.BLUE_COLOR &&
            `
        background: ${UIStyleConstants.BLUE_LIGHT_COLOR}
        color: ${UIStyleConstants.WHITE_COLOR};
        &:hover {
            background: ${UIStyleConstants.BLUE_COLOR};
        }
    `}
        border-radius: 4px;

        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 24px;

        @media (min-width: 768px) {
            height: calc(28px + 4 * (100vw - 768px) / 598);
            font-size: calc(10px + 2 * (100vw - 1366px) / 554);
        }

        @media (min-width: 1366px) {
            height: calc(32px + 10 * (100vw - 1366px) / 554);
            font-size: calc(12px + 3 * (100vw - 1366px) / 554);
            line-height: calc(15px + 4 * (100vw - 1366px) / 554);
        }

        @media (min-width: 1920px) {
            width: 86px;
            height: 42px;
            font-size: 15px;
            line-height: 19px;
        }
    }
`;
